import './style.scss';

const setChildLink = () => {
	const parents = document.getElementsByClassName('wp-block-nssb-blocks-purpose-toc-list');

	if(!parents || parents.length === 0) return;

	[...parents].forEach(parent => {
		const childrenLink = parent.querySelectorAll('.index-purpose-toc-item__link');
		const parentLinkElem = parent.querySelector('.index-purpose-toc__media-link');

		const parentLink = parentLinkElem.href;

		if (!childrenLink || childrenLink.length === 0) return;

		// const parentSlug = parent.dataset.parent;

		childrenLink.forEach(childLink => {
			childLink.href = `${parentLink}#${childLink.dataset.child}`;
		})
	})
}
setChildLink();